<template>
  <div v-if="$viewport.isMobile" class="writeGridLineItem work-permit-option gap-0 ">
    <p class="work-permit-option-label">
      <span class="py-2">{{ title }}</span>
      <span v-if="modelValue.상태 === '승인'" class="flex items-center gap-1" style="color: #28C76F; font-weight: 700">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF"/>
          <path d="M13.6436 5.95214C13.5413 5.85511 13.4039 5.80078 13.2607 5.80078C13.1175 5.80078 12.98 5.85511 12.8778 5.95214L7.95419 10.824L5.98471 8.8117C5.93769 8.75101 5.87776 8.7008 5.80895 8.66448C5.74013 8.62817 5.66408 8.60658 5.5859 8.6012C5.50772 8.59582 5.42921 8.60676 5.35578 8.63329C5.28235 8.65982 5.21567 8.70133 5.16024 8.75498C5.10482 8.80863 5.06197 8.87317 5.03456 8.94425C5.00716 9.01533 4.99582 9.09126 5.00137 9.16694C5.00693 9.24262 5.02924 9.31627 5.06675 9.38288C5.10427 9.44949 5.15617 9.50753 5.21888 9.55305L7.6259 11.989C7.6259 12.0949 7.84478 12.2008 7.95419 12.2008C8.03912 12.2008 8.12285 12.1816 8.19881 12.1449C8.27477 12.1081 8.34085 12.0547 8.39181 11.989L13.6436 6.69352C13.7438 6.59453 13.8 6.46144 13.8 6.32283C13.8 6.18422 13.7438 6.05113 13.6436 5.95214Z" fill="#28C76F"/>
        </svg>
        허가승인
      </span>
      <span v-if="modelValue.상태 === '반려'" class="flex items-center gap-1" style="color: #EA5455; font-weight: 700">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
        </svg>
        반려
      </span>
    </p>
    <p style="font-weight: 700;">승인자:<span class="ml-1" style="font-weight: 400;">
                {{ modelValue.승인자.부서 }} {{ modelValue.승인자.직책 }} {{ modelValue.승인자.성명 }}</span></p>
    <p class="mb-6" style="margin-top: 4px; font-weight: 700;">허가승인일시:<span class="ml-1" style="font-weight: 400;">
                {{ new Date(modelValue.승인일시).format('yyyy-MM-dd, HH:mm') }}</span></p>
    <slot>
      <radio-group class="w-full"
                   v-model="modelValue.상태"
                   flex mobileView
                   :readonly="readonlyRadio || !isSafetyManager"
                   :items="['대기', '승인', '반려']"
                   :activeColor="{
                   '대기' : { color: '#3c3c3c', background: '#DCDFE2' },
                   '승인' : { color: '#ffffff', background: '#28C76F' },
                   '반려' : { color: '#ffffff', background: '#EA5455' },
                 }"
                   @input="onSelect"/>
    </slot>

    <div v-if="modelValue.error" class="w-full flex items-center mt-4">
      <slot name="error">
        <svg class="mr-2 order-1" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
        </svg>
        <span class="order-2" style="color:#EA5455">{{modelValue.error}}</span>
      </slot>
    </div>
  </div>
  <div v-else class="writeGridLineItem">
    <div class="font-medium">{{ title }}</div>
    <div class="flex flex-wrap gap-x-6 gap-y-2 align-center" style="align-self: center;">
      <slot>
        <radio-group v-model="modelValue.상태"
                     flex
                     :readonly="readonlyRadio || !isSafetyManager"
                     :items="['대기', '승인', '반려']"
                     @input="onSelect"/>
      </slot>

      <!-- 작업승인 - 승인 -->
      <div v-if="modelValue.상태 === '승인'" class="flex items-center gap-6">
              <span class="flex items-center gap-1" style="color: #28C76F; font-weight: 700">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF"/>
                  <path d="M13.6436 5.95214C13.5413 5.85511 13.4039 5.80078 13.2607 5.80078C13.1175 5.80078 12.98 5.85511 12.8778 5.95214L7.95419 10.824L5.98471 8.8117C5.93769 8.75101 5.87776 8.7008 5.80895 8.66448C5.74013 8.62817 5.66408 8.60658 5.5859 8.6012C5.50772 8.59582 5.42921 8.60676 5.35578 8.63329C5.28235 8.65982 5.21567 8.70133 5.16024 8.75498C5.10482 8.80863 5.06197 8.87317 5.03456 8.94425C5.00716 9.01533 4.99582 9.09126 5.00137 9.16694C5.00693 9.24262 5.02924 9.31627 5.06675 9.38288C5.10427 9.44949 5.15617 9.50753 5.21888 9.55305L7.6259 11.989C7.6259 12.0949 7.84478 12.2008 7.95419 12.2008C8.03912 12.2008 8.12285 12.1816 8.19881 12.1449C8.27477 12.1081 8.34085 12.0547 8.39181 11.989L13.6436 6.69352C13.7438 6.59453 13.8 6.46144 13.8 6.32283C13.8 6.18422 13.7438 6.05113 13.6436 5.95214Z" fill="#28C76F"/>
                </svg>
                허가승인
              </span>
        <p style="font-weight: 700;">승인자:<span class="ml-1" style="font-weight: 400;">
                {{ modelValue.승인자.부서 }} {{ modelValue.승인자.직책 }} {{ modelValue.승인자.성명 }}</span></p>
        <p style="font-weight: 700;">허가승인일시:<span class="ml-1" style="font-weight: 400;">
                {{ new Date(modelValue.승인일시).format('yyyy-MM-dd, HH:mm') }}</span></p>
      </div>

      <!-- 작업승인 - 반려 -->
      <div v-if="modelValue.상태 === '반려'" class="flex items-center gap-6">
              <span class="flex items-center gap-1" style="color: #EA5455; font-weight: 700">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
                </svg>
                반려
              </span>
        <p style="font-weight: 700;">승인자:<span class="ml-1" style="font-weight: 400;">
                {{ modelValue.승인자.부서 }} {{ modelValue.승인자.직책 }} {{ modelValue.승인자.성명 }}</span></p>
        <p style="font-weight: 700;">허가승인일시:<span class="ml-1" style="font-weight: 400;">
                {{ new Date(modelValue.승인일시).format('yyyy-MM-dd, HH:mm') }}</span></p>
      </div>

      <div v-if="modelValue.error" class="w-full flex items-center">
        <slot name="error">
          <svg class="mr-2 order-1" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
          </svg>
          <span class="order-2" style="color:#EA5455" v-html="modelValue.error"></span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: "WorkPermitOption",
  components: {RadioGroup},
  props: {
    title: String,
    value: Object,
    readonlyRadio: Boolean, // 라디오버튼 읽기전용
    isSafetyManager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    onSelect(value) {
      this.$emit("select", value);

      // 승인자 정보 변경 시 전체 객체를 복사하여 업데이트 알림
      if (this.modelValue.상태 === "승인" || this.modelValue.상태 === "반려") {
        this.updateParent();
      } else if (this.modelValue.상태 === "대기") {
        // 대기 상태일 때는 승인자 정보 초기화
        this.modelValue.승인자 = {
          부서: "",
          소속: "",
          직책: "",
          성명: "",
        };
      }
    },

    // 승인자 정보 변경을 감지하고 부모에게 알리는 헬퍼 메서드 추가
    updateParent() {
      // 전체 객체의 복사본을 만들어 참조 문제 방지
      const updatedModel = JSON.parse(JSON.stringify(this.modelValue));
      this.$emit("input", updatedModel);
    }
  },
}
</script>

<style scoped lang="scss">
.work-permit-option {
  width: calc(100% - 10px);
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  box-shadow: 0px 2px 8px 0px #00000021;
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  p { width: 100%; }
}

.work-permit-option-label {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  span {
    font-weight: 700;
    color: #3C3C3C;
    font-size: 16px;
    margin-bottom: 12px;
  }
}
</style>
